<template>
  <div id="createIntention">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/skillList' }">技能列表</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/intentionList?skillId='+this.skill_id +'&online='+this.online, }">意图列表</el-breadcrumb-item>
      <el-breadcrumb-item>系统意图列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div id="intentionInfo">
      <p class="title">系统意图列表</p>
      <div class="intContainer">
        <template>
          <el-table
            :data="tableData"
            align="center">
            <el-table-column
              prop="chinese_name"
              align="center"
              label="意图中文名">
            </el-table-column>
            <el-table-column
              prop="intent"
              align="center"
              label="意图标识名">
            </el-table-column>
            <el-table-column
              align="center"
              label="引用状态">
              <template slot-scope="scope">
                <el-switch
                  :width="36"
                  v-model="scope.row.ref_state"
                  @change="SysInt(scope.row)"
                  active-color="#409EFF"
                  inactive-color="#dcdcdc">
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="操作">
              <template slot-scope="scope">
                <el-button size="mini" type="text"
                           @click="toIntentionDeatil(scope.row)">
                  查看详情
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
    </div>

  </div>
</template>
<script>
  import qs from 'qs'
  import {sysListApi, refSysIntApi, calSysIntApi} from '@/api'

  export default {
    data() {
      return {
        skill_id: '',
        online: '',
        value2: true,
        tableData: []
      }
    },
    created() {
      this.skill_id = this.$route.query.skillId
      this.online = this.$route.query.online
      this.sysList()
    },
    methods: {
      toIntentionDeatil(row){
        this.$router.push({path: '/intentionDeatil?skillId='+this.skill_id+'&intent_id='+row.id+'&ref_state='+row.ref_state+'&online='+this.online})
      },
      async SysInt(val) {
        if (val.ref_state) {
            console.log(qs.stringify({skill_id: this.skill_id, intents: [val.id]}))
            console.log(qs.parse(qs.stringify({skill_id: this.skill_id, intents: [val.id]})))
            let res = await refSysIntApi(qs.stringify({skill_id: this.skill_id, intents: [val.id]}))
        } else {
          let res = await calSysIntApi(qs.stringify({skill_id: this.skill_id, intents: [val.id]}))
        }
      },
      async sysList() {
        this.skill_id = this.$route.query.skillId
        let res = await sysListApi(this.skill_id)
        if (res.data.code == 200) {
          this.tableData = res.data.data
        } else {
          this.$message({message: '获取系统意图列表失败', type: 'error'})
        }
      }
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss">
  #createIntention {
    .el-switch__core {
      height: 20px;
    }
    /*.el-switch__button {*/
      /*width: 14px;*/
      /*height: 14px;*/
      /*top: 0;*/
    /*}*/
    background: #f7f7f7;
    .title {
      height: 64px;
      line-height: 64px;
      padding-left: 30px;
      font-size: 16px;
      color: #2e4d79;
      border-bottom: 1px solid #f5f5f5;
      border-left: 2px solid #010202;
    }
    #intentionInfo {
      background: #fff;
      .intContainer {
        margin: 0;
        padding: 20px 30px 30px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/skill/intention/SystemList.vue